import { Trans } from 'react-i18next';

interface IProps {
  fileName: string;
  acceptFileTypes: string[];
  allowTranslation: boolean;
}

const ErrorFileType = ({ fileName, acceptFileTypes, allowTranslation = false }: IProps) => {
  const userFriendlyTypes = acceptFileTypes
    .map((type) => {
      // select file type from file extension notation
      let filetype = type.substring(type.lastIndexOf('.') + 1);
      // select file type from  MIME type notation
      const split = type.split('/');
      if (split.length > 1) {
        /* eslint-disable prefer-destructuring */
        filetype = type.split('/')[1];
      }
      return filetype;
    })
    .join(', ');

  return allowTranslation ? (
    <span>
      <Trans ns="ui" i18nKey="photoUploadFileType.validation">
        {{ fileName }}
        <div>wasn't uploaded.</div>
        Allowed file types: <strong>{{ userFriendlyTypes }}</strong>.
      </Trans>
    </span>
  ) : (
    <span>
      {fileName}
      <div>wasn't uploaded.</div> Allowed file types: <strong>{userFriendlyTypes}</strong>.
    </span>
  );
};

export default ErrorFileType;
